import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PersonalFileInfo } from '../../../../../shared/models/PersonalFileInfo';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'delete-file-dialog',
    templateUrl: './delete-file-dialog.component.html',
    styleUrls: ['./delete-file-dialog.component.css'],
    standalone: false
})
export class DeleteFileDialogComponent implements OnInit {

  fileDeleteForm!: UntypedFormGroup;
  fileInfo!:PersonalFileInfo;
//  userName!: string;

  constructor(
    private fb: UntypedFormBuilder,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DeleteFileDialogComponent>,
    private tenantService: TenantService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) 
  { }

  ngOnInit() {

    this.fileInfo = this.data.fileInfo;
    console.log("========================> fileInfo = ", this.fileInfo);
    this.buildFileDeleteForm(this.fileInfo);
  }

  buildFileDeleteForm(file: PersonalFileInfo) {
    this.fileDeleteForm = this.fb.group({
      fileName:[this.fileInfo.fileName]
    });
  }

  deleteFile(fileName: string) {
    if(this.fileDeleteForm.valid){      
      this.dialogRef.close(this.fileDeleteForm.value);
    }
  }

  cancel(){
    this.dialogRef.close();
  }
}
